import React from 'react';
import BonusCounter from "./bonusCounter";

const TopLine = () => {
    return (
        <div className={'top_line'}>
            <div className="container">
                <div className="top_line_wrapper">
                    <p className={'top_line_content'}>
                        <span className={'hide'}>50% FLASH SALE - </span>Use Code <span className={'code'}>‘50FLASH’</span> to Get Extra Tokens
                    </p>
                    <BonusCounter
                        dueDate={1755820800000}
                    />
                </div>
            </div>
        </div>
    );
};

export default TopLine;